import { observer } from 'mobx-react';
import React, { FC, useCallback } from 'react';

import { OrderPageStore } from 'app/logic/pages/order/OrderPageStore';

import { LatinFormItem } from './LatinFormItem';

export interface NameEngFormItemProps {
    /**
     * Стор страницы.
     */
    pageStore: OrderPageStore;
}

export const NameEngFormItem: FC<NameEngFormItemProps> = observer(
    ({ pageStore }) => {
        const onChangeHandler = useCallback(
            (nameLatin: string) =>
                pageStore.orderFormStore.setNameLatin(nameLatin),
            [pageStore.orderFormStore],
        );

        return (
            <LatinFormItem
                defaultValue={
                    pageStore.orderFormStore.nameLatin?.toUpperCase() ?? ''
                }
                placeholder={'Имя латиницей'}
                formItemName={'nameLatin'}
                onChangeFormItemValue={onChangeHandler}
            />
        );
    },
);
